export {
  REMOTE_FETCH_RETRIES,
  REMOTE_FETCH_RETRY_DELAY_MS,
  fetchWithRetry,
  isOnline,
  mapRpcError,
  parseBranchCashSessionReportRow,
  parseCashSessionRow,
  rpcVentasProductFilters,
} from './reportsRemoteShared';

export type {
  ReportsOperacionSource,
  ReportsOperacionKpiSources,
  BranchCashSessionReportRow,
  PosExceptionSummary,
  SalesDailyRow,
  ReportsVentasProductScope,
  SalesByProductSortKey,
  BranchSalesByProductRow,
  BranchSalesByProductResponse,
} from './reportsRemoteShared';

export {
  fetchRemoteBranchCashSessions,
  fetchRemoteCashClosuresHistory,
  fetchRemoteCashClosuresCount,
  fetchRemoteBranchCashSummary,
  fetchRemoteCashActivity,
} from './reportsRemoteCashRepo';

export type {
  RemoteCashClosuresQuery,
  CashActivityKind,
  CashActivityItem,
} from './reportsRemoteCashRepo';

export {
  fetchRemoteSalesSnapshot,
  fetchRemotePosExceptionSummary,
  fetchRemoteSalesDaily,
  fetchRemoteBranchSalesByProduct,
  fetchRemoteSalesRangeTotals,
  fetchRemoteSalesTimeBands,
  fetchRemoteSalesComparison,
  fetchRemoteSalesByCashier,
} from './reportsRemoteSalesRepo';

export {
  fetchRemoteListSales,
  fetchRemoteSaleDetail,
} from './reportsRemoteSalesListRepo';

export { fetchRemoteBranchStockMermaByProduct } from './reportsRemoteStockMermaRepo';
